import React from "react";
import { Link } from "react-router-dom";

/**
 * `items`: [{ label, to? }]. The last item is the current page and never a link.
 */
const Breadcrumbs = ({ items }) => (
  <nav className="hc-crumbs" aria-label="Breadcrumb">
    {items.map((item, index) => {
      const isLast = index === items.length - 1;

      return (
        <span key={item.to || item.label} className="hc-crumbs__item">
          {isLast || !item.to ? (
            <span aria-current={isLast ? "page" : undefined}>{item.label}</span>
          ) : (
            <Link to={item.to}>{item.label}</Link>
          )}
          {isLast ? null : (
            <span className="hc-crumbs__sep" aria-hidden="true">
              /
            </span>
          )}
        </span>
      );
    })}
  </nav>
);

export default Breadcrumbs;
